export default "__VITE_ASSET__q27PxFaR__"